<template>
  <div class="testimonial-section">
    <h2 class="uk-text-center uk-article-title AppTitle Title"><a class="uk-link-reset">{{'testimonials'|translate}}</a>
    </h2>
    <div uk-slider="center: true; autoplay: true; autoplay-interval: 5000">
      <div class="uk-position-relative">
        <div class="uk-slider-container">
          <ul class="uk-slider-items uk-child-width-1-2 uk-child-width-1-3@m uk-grid">
            <li v-for="(item, index) in items" :key="index">
              <div class="uk-cover-container testimonial">
                <div class="uk-card-body">
                  <p class="description">{{item.description}}</p>
                  <h5 class="uk-card-title title">{{item.user}} - {{item.country}}</h5>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="uk-hidden@s uk-light">
          <a class="uk-position-center-left uk-position-small" href="#" uk-slidenav-previous
             uk-slider-item="previous"></a>
          <a class="uk-position-center-right uk-position-small" href="#" uk-slidenav-next uk-slider-item="next"></a>
        </div>
        <div class="uk-visible@s">
          <a class="uk-position-center-left-out uk-position-small" href="#" uk-slidenav-previous
             uk-slider-item="previous"></a>
          <a class="uk-position-center-right-out uk-position-small" href="#" uk-slidenav-next
             uk-slider-item="next"></a>
        </div>
      </div>
      <ul class="uk-slider-nav uk-dotnav uk-flex-center uk-margin"></ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PropertyTestimonials',
  props: ['items']
}
</script>

<style scoped>
  .testimonial-section {
    margin-top: 80px;
  }

  .testimonial .title {
    font-size: 16px;
    font-weight: 600;
  }

  .testimonial .uk-card-body {
    background: #ff480012;
  }

  .testimonial .description {
    min-height: 100px;
  }
</style>
